// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"244":"cc88605b","352":"02328ab9","436":"e4940eff","864":"9b1c5ed0","910":"d1ae4e2e"}[chunkId] + ".chunk.js";
};